import { render } from "./GracePeriod.vue?vue&type=template&id=0ee94c8e&scoped=true"
import script from "./GracePeriod.vue?vue&type=script&lang=js"
export * from "./GracePeriod.vue?vue&type=script&lang=js"

import "./GracePeriod.vue?vue&type=style&index=0&id=0ee94c8e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee94c8e"]])

export default __exports__